import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { ArtChildrenEventListProps } from "./types";
import { PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";

export class ArtChildrenEventListDefinitions extends CmsReactComponent<ArtChildrenEventListProps> {
    static schemaName = "art-festival-event-list";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            text: "Başlık",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "description",
            mapping: {
                type: PropertyMappingType.Textarea,
            },
            text: "Açıklama",
        },
        {
            name: "eventType",
            text: "Çocuk Sanat Etkinlik Türü (ID)",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "video",
            mapping: {
                type: PropertyMappingType.Video,
            },
            description: "Hero video",
        },
        {
            name: "hero",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Hero görseli Desktop",
        },
        {
            name: "heroMobile",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Hero görseli Desktop",
        },
        {
            name: "figure",
            mapping: {
                type: PropertyMappingType.Image,
            },
            description: "Hero görseli Desktop",
        },
        {
            mapping: {
                type: PropertyMappingType.File,
            },
            name: "calendar",
            description: "Aylık bülten dosyası seçiniz",
            text: "Aylık Bülten",
        },
        {
            mapping: {
                type: PropertyMappingType.Html,
            },
            name: "ticket",
            text: "Biletlendirme açıklaması",
        },
        {
            mapping: {
                type: PropertyMappingType.Number,
            },
            name: "year",
            text: "Yıl",
            description:"Eski tarih ise yıl giriniz. (Örn: 2019) yeni tarih ise boş bırakınız.",
        }
    ];
}
